







import echarts, { EChartOption } from 'echarts'
import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import ResizeMixin from '@/components/Charts/mixins/resize'

const animationDuration = 6000

@Component({
  name: 'BarChart'
})
export default class extends mixins(ResizeMixin) {
  @Prop({ default: 'chart' }) private className!: string
  @Prop({ default: '100%' }) private width!: string
  @Prop({ default: '350px' }) private height!: string

  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  }

  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  }

  private initChart() {
    this.chart = echarts.init(this.$el as HTMLDivElement, 'macarons')
    this.chart.setOption({
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      grid: {
        top: '10%',
        left: '3%',
        right: '2%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: [{
        type: 'category',
        data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        axisTick: {
          alignWithLabel: true
        }
      }],
      yAxis: [{
        type: 'value',
        name: 'Hours',
        nameLocation: 'middle',
        nameGap: 25,
        boundaryGap: false,
        axisTick: {
          show: false
        }
      }],
      series: [{
        name: 'Running',
        type: 'bar',
        stack: 'vistors',
        itemStyle: {normal: {color: '#6BD7DB'}},
        // barWidth: '60%',
        data: [165, 201, 129, 171, 213, 93, 36],
        animationDuration
      }, {
        name: 'Stopped',
        type: 'bar',
        stack: 'vistors',
        itemStyle: {normal: {color: '#F7CC95'}},
        // barWidth: '60%',
        data: [645, 609, 682, 629, 603, 715, 777],
        animationDuration
      }, {
        name: 'Terminated',
        type: 'bar',
        stack: 'vistors',
        itemStyle: {normal: {color: '#E08B8E'}},
        // barWidth: '60%',
        data: [6, 9, 9, 15, 15, 18, 21],
        animationDuration
      }]
    } as EChartOption<EChartOption.SeriesBar>)
  }
}
